import type React from 'react';

import { cn, Separator } from '#src/app/shared/components/adminShadcn';

export const LabeledSeparator: React.FC<{
	label: string;
	className?: string;
	/** Background applied to the label so it masks the line behind it; should match the container. */
	labelClassName?: string;
	/** Extra classes for the separator line (e.g. to colour it). */
	lineClassName?: string;
}> = ({ label, className, labelClassName = 'admin:bg-muted', lineClassName }) => {
	return (
		<div className={cn('admin:relative admin:flex admin:items-center admin:justify-center', className)}>
			<Separator decorative={false} className={cn('admin:absolute admin:inset-x-0', lineClassName)} />
			<span
				className={cn(
					'admin:relative admin:px-2 admin:text-xs admin:font-medium admin:text-muted-foreground',
					labelClassName,
				)}
			>
				{label}
			</span>
		</div>
	);
};
